import { RolePermissionMapping } from '@traton/devportal-rbac-common-lib';

import { portalUser } from './roles';
import {
  developerPortalSupportAgentReadPermission,
  developerPortalSupportAgentCreatePermission,
  developerPortalSupportAgentUpdatePermission,
  developerPortalSupportAgentDeletePermission,
} from './permissions';

export const roleMapping: RolePermissionMapping = new Map([
  [
    portalUser,
    [
      developerPortalSupportAgentReadPermission,
      developerPortalSupportAgentCreatePermission,
      developerPortalSupportAgentUpdatePermission,
      developerPortalSupportAgentDeletePermission,
    ],
  ],
]);
